import fetch from './fetch'

// 查询详细信息
export function getAuthorInfo() {
	return fetch({
		url: `/login/info`,
		method: 'get'
	})
}

// 邮箱登录
export function doEmailLogin(data) {
	return fetch({
		url: '/email/login',
		method: 'post',
		data
	})
}

// 手机号登录
export function doTelLogin(data) {
	return fetch({
		url: '/mobile/login',
		method: 'post',
		data
	})
}

// 注销登录
export function doLogout() {
	return fetch({
		url: '/logout',
		method: 'get'
	})
}

export function sendSms(data) {
	return fetch({
		url: '/send/smscode',
		method: 'post',
		data
	})
}

export function getCapThurl(url) {
	return process.env.AUTHOR_API + '/authors' + url
}

export function register(data) {
	return fetch({
		url: '/author/apply',
		method: 'post',
		data
	})
}

//添加申请记录
export function signApply(data) {
	return fetch({
		url: '/sign_apply',
		method: 'post',
		data
	})
}

//查询作家信息
export function authorInfo(id) {
	return fetch({
		url: `/${id}`,
		method: 'get',
	})
}

// 验证作者笔名是否存在
export function checkPenName(data) {
	return fetch({
		url: '/name/exist',
		method: 'post',
		data
	})
}

// 是否需要输入验证码
export function showCaptcha_api(data) {
	return fetch({
		url: '/allow/captcha',
		method: 'post',
		data
	})
}

// 获取用户信息
export function getUserInfo_api() {
	return fetch({
		url: '/user/info',
		method: 'get'
	})
}

// sd 登录
export function sdLogin() {
	return fetch({
		url: '/sd/login',
		method: 'post'
	})
}



// WEBPACK FOOTER //
// ./src/api/user.js